<template>
	<el-row type="flex" justify="center" align="middle">
		<el-date-picker
			style="width: 200px"
			v-model="datePicker"
			value-format="yyyyMMdd"
			format="yyyyMMdd"
			unlink-panels
			@change="dateChange"
			type="daterange"
			:range-separator="$t('至')"
			start-placeholder="开始日期"
			end-placeholder="结束日期"
			:picker-options="pickerOptions">
		</el-date-picker>
	</el-row>
</template>

<script>
export default {
	name: "PickerRiQi",
	model: {
		prop: "pageInfo",
		event: "change",
	},
	props: ["ksrq", "jsrq"],
	data() {
		return {
			datePicker: [this.$moment(this.ksrq).format("YYYYMMDD"), this.$moment(this.jsrq).format("YYYYMMDD")],
			pickerOptions: {
				shortcuts: [
					{
						text: this.$t('今日'),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							// start.setTime(start.getTime());
							// end.setTime(end.getTime());
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text:this.$t('昨日'),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
							end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("本周"),
						onClick(picker) {
							const now = new Date();
							const nowTime = now.getTime();
							const day = now.getDay() > 0 ? now.getDay() : 7;
							const oneDayTime = 24 * 60 * 60 * 1000;
							const MondayTime = nowTime - (day - 1) * oneDayTime;
							const start = new Date(MondayTime);
							picker.$emit("pick", [start, now]);
						},
					},
					{
						text: this.$t("本月"),
						onClick(picker) {
							const date = new Date();
							const year = date.getFullYear();
							const month = date.getMonth() + 1;
							const formattedFirstDay = `${year}-${month.toString().padStart(2, "0")}-01`;
							const start = new Date(formattedFirstDay);
							picker.$emit("pick", [start, date]);
						},
					},
					{
						text: this.$t("本年"),
						onClick(picker) {
							const end = new Date();
							const start = new Date(new Date().getFullYear(), 0);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("最近一周"),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("最近一个月"),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("最近三个月"),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("所有日期"),
						onClick(picker) {
							const end = new Date();
							const start = new Date('1900-01-01');
							// start.setTime("19000101");
							picker.$emit("pick", [start, end]);
						},
					},
				],
			},
		};
	},
	methods: {
		dateChange() {
			this.$emit("dateChange", this.datePicker);
		},
	},
};
</script>
